import useApi from './useApi';

const useAccommodationService = () => {
  const { api } = useApi();

  // Accommodations managment

  const getAllAccommodations = () => api({
    method: 'get',
    url: '/product-marketing/v1/establishments/own/accommodations',
  });

  const getAccommodation = (accommodationId) => api({
    method: 'get',
    url: `/product-marketing/v1/establishments/own/accommodations/${accommodationId}`,
  });

  const postAccommodation = (accommodation) => api({
    method: 'post',
    url: '/product-marketing/v1/establishments/own/accommodations',
    data: accommodation,
  });

  const putAccommodation = ({ accommodationId, accommodation }) => api({
    method: 'put',
    url: `/product-marketing/v1/establishments/own/accommodations/${accommodationId}`,
    data: accommodation,
  });

  const putAccommodationTranslations = ({ accommodationId, langCode, translations }) => api({
    method: 'put',
    url: `/product-marketing/v1/establishments/own/accommodations/${accommodationId}/translations/${langCode}`,
    data: translations,
  });

  // Static data

  const getAccommodationFeatures = () => api({
    method: 'get',
    url: '/product-marketing/v1/accommodation-features',
  });

  const getAccommodationTypes = () => api({
    method: 'get',
    url: '/product-marketing/v1/accommodation-types',
  });

  return {
    getAllAccommodations,
    getAccommodation,
    postAccommodation,
    putAccommodation,
    putAccommodationTranslations,
    getAccommodationFeatures,
    getAccommodationTypes,
  };
};

export default useAccommodationService;
